import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { adrEntityContentExtension } from '@backstage-community/plugin-adr/alpha';
import { simCorpFilePathFilter } from '@internal/plugin-simcorp-adr-common';

/**
 * Frontend module that overrides the ADR entity content extension to inject
 * a custom filePathFilterFn into EntityAdrContent.
 *
 * Add this module to the `features` array in App.tsx alongside `adrPlugin`.
 */
export const adrModule = createFrontendModule({
  pluginId: 'adr',
  extensions: [
    adrEntityContentExtension.override({
      params: {
        loader: async () => {
        const { EntityAdrContent } = await import(
          '@backstage-community/plugin-adr'
        );
        return <EntityAdrContent filePathFilterFn={simCorpFilePathFilter} />;
        },
      },
    }),
  ],
});
